import React from "react";
import { UseFormRegister, FieldErrors, Control, useFieldArray } from "react-hook-form";
import InputField from "../../../components/form/InputField";
import ButtonSelect from "../../../components/form/ButtonSelect";
import SubTitle from "../../../components/ui/SubTitle";
import { useTranslation } from "react-i18next";
import { Sector } from "../../../types/modules/sector.type";
import { PageBasicFormFormData } from "../../../pages/owner/store/CreateStoreBasicPage";

interface Props {
  register: UseFormRegister<PageBasicFormFormData>;
  errors: FieldErrors<PageBasicFormFormData>;
  control: Control<PageBasicFormFormData>;
  selectedSectorId:number|null,
  onSelectSector:(id:number)=>void,
  sectors:Sector[]
}

const StoreBasicInfoForm: React.FC<Props> = ({
  register,
  errors,
  control,
  selectedSectorId,
  onSelectSector,
  sectors
}) => {
  const { fields } = useFieldArray({ control, name: "name" });
  const { t } = useTranslation();

  return (
    <>
      <div className="grid md:grid-cols-2 gap-5">
        {fields.map((field, idx) => (
        <div key={field.id} className="mb-4">
          <InputField
            label={`${t('brand_name')} (${field.languageCode})`}
            placeholder={`${t('brand_name_placeholder')} (${field.languageCode})`}
            register={register(`name.${idx}.brand`)}
            error={errors.name?.[idx]?.brand}
          />
          
          <input type="hidden" {...register(`name.${idx}.languageCode`)} value={field.languageCode} />
        </div>
      ))}
      </div>

      <div>
        <SubTitle title={t("sector_type")} />
        <ButtonSelect
          options={sectors.map(s => ({ id: s.id, label: s.languages[0].name }))}
          selected={selectedSectorId}
          onSelect={onSelectSector}
        />
      </div>
    </>
  );
};

export default StoreBasicInfoForm;
